import { render, staticRenderFns } from "./NoActions.vue?vue&type=template&id=20cbe843&"
import script from "./NoActions.vue?vue&type=script&lang=js&"
export * from "./NoActions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports